module.exports = __webpack_public_path__ + "static/media/3 Lapel.042520a7.jpg";